'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _AnalyticsData() {
  var _analyticsData;

  this.analyticsData = (_analyticsData = {
    productNames: {
      card: 'Spending',
      crypto: 'Crypto',
      loan: 'Money',
      creditscore: 'Credit Score',
      mortgage: 'Mortgage'
    },

    'virtual-page-view': {
      event: 'DLevent.Pageview',
      Page: function Page(pageName) {
        if (pageName) {
          return pageName;
        }
        return window.location.href;
      }
    },
    'generic-push-event': {
      event: function event(DLevent) {
        return 'DLevent.' + DLevent;
      }
    },
    'generic-event': {
      event: 'DLevent.genericEvent',
      category: function category(_category) {
        return _category;
      },
      action: function action(_action) {
        return _action;
      },
      label: function label(_label) {
        return _label;
      }
    },
    'connection-issue': {
      event: 'DLevent.ServerIssue',
      Issue: function Issue(issue) {
        return issue;
      },
      ProductAffected: function ProductAffected(productLabel) {
        return productLabel;
      }
    },
    'connection-issue-try-again': {
      event: 'DLevent.ServerIssue',
      Issue: function Issue(issue) {
        return issue;
      },
      ProductAffected: function ProductAffected(productLabel) {
        return productLabel;
      }
    },
    'monthly-credit-check-dialog': {
      event: 'DLevent.MonthlyCreditCheck',
      mcc: function mcc(event) {
        return event;
      }
    },

    'field-selected': {
      event: 'DLevent.fieldSubmitted',
      fieldSubmittedName: function fieldSubmittedName(fieldName) {
        return fieldName;
      },
      fieldSubmittedValue: function fieldSubmittedValue(fieldValue) {
        return fieldValue;
      }
    },

    'loan-application-submission': {
      event: 'DLevent.submission',
      submission: function submission(boolean) {
        return boolean;
      }
    },

    'bitcoin-cashback-status': {
      event: 'DLevent.genericEvent',
      category: 'MogoCard ',
      action: 'bitcoin cashback',
      label: function label(status) {
        return status;
      }
    },

    'link-bank-account-state': {
      event: 'DLevent.BankAccountState',
      BankAccountState: function BankAccountState(account) {
        if (!account) {
          return 'Not Linked';
        }
        return 'Is Linked';
      },
      BankAccountProduct: function BankAccountProduct(product) {
        return this.analyticsData.productNames[product];
      }
    },
    'link-bank-status': {
      event: 'DLevent.LinkBank',
      LinkBankStatus: function LinkBankStatus(val) {
        if (arguments.length > 0) {
          return val;
        }
      }
    },
    'link-bank-check-bank': {
      event: 'DLevent.BankCheck',
      CheckStatus: function CheckStatus(status) {
        return status;
      },
      BankName: function BankName(bankName) {
        return bankName;
      }
    },
    'link-bank-error': {
      event: 'DLevent.LinkBankError',
      Type: function Type(errorType) {
        switch (errorType) {
          case 'TRY_AGAIN_LATER':
            return 'Try Again Later';
          case 'NOT_SUPPORTED':
            return 'Not Supported';
          case 'NO_ACCOUNTS':
            return 'No Accounts Exist';
          case 'UNEXPECTED_ERROR':
            return 'Unexpected Error';
          default:
            return false;
        }
      }
    },

    'unlock-cashback': {
      event: 'DLevent.memberNavigation',
      memberNavigation: 'MogoCard-Navigation-unlock bitcoin cashback-Navigation-Component'
    },

    'bitcoin-cashback': {
      event: 'DLevent.memberNavigation',
      memberNavigation: 'MogoCard-Navigation-bitcoin cashback-Navigation-Component'
    },

    'link-bank-removal': {
      event: 'DLevent.CardBankRemoval',
      message: function message(hadAutoTransfer) {
        if (hadAutoTransfer) {
          return 'Bank Account and Auto Transfer Removed';
        }
        return 'Bank Account Removed';
      }
    },

    'money-approval': {
      event: 'DLevent.ApprovalStatusUpdate',
      ProductApproved: function ProductApproved(data) {
        var products = {};
        var approvedProduct = '';
        $.each(data.approved_products, function (index, item) {
          products[item.name] = item;
        });

        if (data.credit_check_decision === 'trust_science_pending') {
          approvedProduct = 'Trust science pending';
        } else if (products.liquid && products.liquid.amount) {
          approvedProduct = 'Liquid';
        } else if (products.zip && products.mini && products.zip.amount && products.mini.amount) {
          approvedProduct = 'Zip and Mini';
        } else if (products.mini && products.mini.amount) {
          approvedProduct = 'Mini';
        } else if (products.zip && products.zip.amount) {
          approvedProduct = 'Zip';
        } else {
          approvedProduct = 'Declined';
        }
        return approvedProduct;
      },
      AmountApproved: function AmountApproved(data) {
        var products = {};
        var amount = 0;
        $.each(data, function (index, item) {
          products[item.name] = item;
        });

        if (products.liquid && products.liquid.amount) {
          amount = products.liquid.amount;
        } else if (products.zip && products.mini && products.zip.amount && products.mini.amount) {
          amount = products.zip.amount + products.mini.amount;
        } else if (products.mini && products.mini.amount) {
          amount = products.mini.amount;
        } else if (products.zip && products.zip.amount) {
          amount = products.zip.amount;
        } else {
          amount = '';
        }
        return amount;
      },
      Lender: function Lender(data) {
        var products = {};
        var lender = '';
        $.each(data, function (index, item) {
          products[item.name] = item;
          products[item.name].lenderName = item.lender_id === 1 ? 'Mogo' : 'Goeasy';
        });

        if (products.liquid && products.liquid.amount) {
          lender = products.liquid.lenderName;
        } else if (products.mini && products.mini.amount) {
          lender = products.mini.lenderName;
        } else if (products.zip && products.zip.amount) {
          lender = products.zip.lenderName;
        }
        return lender;
      }
    },

    'targeted-audience': {
      event: 'DLevent.targetedAudience',
      targetedAudience: function targetedAudience(targetAudience) {
        return targetAudience;
      }
    },

    'products-of-interest': {
      event: 'DLevent.ProductsOfInterest',
      loanInterestPurpose: function loanInterestPurpose(loanData) {
        if (loanData) {
          return loanData;
        }
        return 'undefined';
      },
      loanInterestAmount: function loanInterestAmount(loanData) {
        if (loanData) {
          return loanData;
        }
        return 'undefined';
      },
      loanInterest: function loanInterest(loanData) {
        if (loanData) {
          return 'Yes';
        }
        return 'No';
      },
      cardInterest: function cardInterest(spendingData) {
        if (spendingData) {
          return 'Yes';
        }
        return 'No';
      },
      mortgageInterest: function mortgageInterest(mortgageData) {
        if (mortgageData) {
          return 'Yes';
        }
        return 'No';
      },
      creditScoreInterest: function creditScoreInterest(creditScoreData) {
        if (creditScoreData) {
          return 'Yes';
        }
        return 'No';
      },
      identityFraudInterest: function identityFraudInterest(identityFraudData) {
        if (identityFraudData) {
          return 'Yes';
        }
        return 'No';
      },
      bitcoinInterest: function bitcoinInterest(bitcoinInterestData) {
        if (bitcoinInterestData) {
          return 'Yes';
        }
        return 'No';
      }
    },

    'income-validation': {
      event: 'DLevent.incomeValidation',
      incomeValidation: function incomeValidation(value) {
        return value;
      }
    },

    'phone-verification': {
      event: 'DLevent.phoneStatus',
      PhoneVerification: function PhoneVerification(_PhoneVerification) {
        return _PhoneVerification;
      }
    },

    'change-email': {
      ChangeEmail: function ChangeEmail(_ChangeEmail) {
        return _ChangeEmail;
      }
    },

    referral: {
      ReferralCode: function ReferralCode(codeStatus) {
        return codeStatus;
      },

      event: 'DLevent.referral'
    },

    'generic-member-navigation': {
      memberNavigation: function memberNavigation(action) {
        return action;
      },

      event: 'DLevent.memberNavigation'
    },

    'generic-api-response-error': {
      event: function event(DLevent) {
        return 'DLevent.' + DLevent;
      },
      Code: function Code(code) {
        if (arguments.length > 0) {
          return code;
        }
      },
      Key: function Key(key) {
        if (arguments.length > 0) {
          return key;
        }
      },
      Msg: function Msg(msg) {
        if (arguments.length > 0) {
          return msg;
        }
      },
      Property: function Property(property) {
        if (arguments.length > 0) {
          return property;
        }
      }
    },

    'dashboard-home-creditscore-view': {
      event: 'DLevent.CreditRating2017',
      // New Acceptance Criteria  MA-239: the user's credit score, 0 if unavailable
      CreditScore: function CreditScore(_CreditScore) {
        if (_CreditScore) {
          return _CreditScore;
        }
        return 0;
      },

      // Poor | Fair | Good | Very Good | Excellent | Rockstar | no
      'Credit Rating': function CreditRating(CreditBracket) {
        return CreditBracket;
      },
      CreditUpdate: function CreditUpdate(optedIn, originator) {
        var monthlyCreditEligibility = {
          optedIn: 'Opt In',
          optedOut: 'Opt out',
          expired: '3 Months'
        };
        var originators = { user: 'user', system: 'system' };
        if (optedIn) {
          return monthlyCreditEligibility.optedIn;
        }
        if (originator === originators.user) return monthlyCreditEligibility.optedOut;
        if (originator === originators.system) return monthlyCreditEligibility.expired;

        // return status;
      }
    },

    'dashboard-home-cell': {
      event: 'DLevent.homeDashboardCell',
      category: function category(_category2) {
        return _category2;
      },
      type: function type(_type) {
        return _type;
      },
      message: function message(_message) {
        return _message;
      }
    },

    'crypto-nav': {
      event: 'DLevent.memberNavigation',
      memberNavigation: function memberNavigation(type) {
        var section = type.charAt(0).toUpperCase() + type.slice(1);
        return section;
      }
    },

    'crypto-wire-receipt-upload-actions': {
      event: 'DLevent.memberNavigation',
      memberNavigation: function memberNavigation(id) {
        return id;
      }
    },

    'file-upload-event': {
      event: function event(action) {
        return 'DLevent.' + action;
      },
      type: function type(_type2) {
        return _type2;
      },
      category: function category(product) {
        return product;
      }
    },

    'dashboard-home-crypto-view': {
      event: 'DLevent.MogoCryptoStatus',
      MogoCryptoStatus: function MogoCryptoStatus(status) {
        return status;
      }
    },

    'dashboard-home-crypto-navigation': {
      event: 'DLevent.memberNavigation',
      memberNavigation: function memberNavigation(CTAText) {
        return 'Crypto - ' + CTAText;
      }
    },

    'crypto-status': {
      event: 'DLevent.MogoCryptoStatus',
      MogoCryptoStatus: function MogoCryptoStatus(status) {
        return status;
      }
    },

    'crypto-holdings': {
      event: 'DLevent.CryptoHoldings',
      Currency: function Currency(type) {
        return type;
      },
      Total: function Total(amount) {
        return amount;
      }
    },

    'crypto-performance': {
      event: 'DLevent.cryptoTradePerformance',
      cryptoTradePerformance: function cryptoTradePerformance(amount) {
        return amount;
      }
    },

    'crypto-live-price': {
      event: 'DLevent.BTCStatus',
      btcValue: function btcValue(price) {
        return price;
      },
      btcChangeDirection: function btcChangeDirection(percentChange, percentChangeABS) {
        return percentChange == percentChangeABS ? 'Up' : 'Down';
      },
      btcChangePercent: function btcChangePercent(percentChange) {
        return Math.abs(percentChange).toFixed(2);
      }
    },

    'crypto-chart-timeframe': {
      event: 'DLevent.CryptoGraphTimeSelection',
      CryptoGraphTimeSelection: function CryptoGraphTimeSelection(timeframe) {
        var selection = '';
        switch (timeframe) {
          case 'day':
            selection = '24hr View';
            break;
          case 'week':
            selection = 'Week View';
            break;
          case 'month':
            selection = 'Month View';
            break;
          case 'year':
            selection = 'Year View';
            break;
          case 'all':
            selection = 'All View';
            break;
        }
        return selection;
      }
    },

    'crypto-chart-highlight-time': {
      event: 'DLevent.marketChartHighlightTime',
      marketChartHighlightTime: function marketChartHighlightTime(timespan) {
        return timespan;
      }
    },

    'crypto-eTransfer-copy': {
      event: 'DLevent.eTransferCopy',
      eTransferCopy: function eTransferCopy(fieldName) {
        return fieldName;
      }
    },

    'crypto-bank-status': {
      event: 'DLevent.MogoCryptoBankStatus',
      CryptoBankStatus: function CryptoBankStatus(status) {
        switch (status) {
          case 'initiated':
            return 'Initiated';
          case 'pending':
            return 'Pending';
          case 'confirmed':
            return 'Confirmed';
          case 'error':
            return 'Error';
          case 'failed':
            return 'Failed';
          default:
            return 'Not set';
        }
      }
    },

    mortgagePopup: {
      event: 'DLevent.mortgageUI',
      mortgageUI: function mortgageUI(ui) {
        return ui;
      }
    },

    // Should be named dashboard-home-mortgage-view, analytics wants mortgageInfo
    mortgageInfo: {
      event: 'DLevent.mortgageInfo',
      // Ineligible|Eligible|In-progress|**Submitted**|Reviewed|Signed|Funded
      mortgageStatus: function mortgageStatus(_mortgageStatus) {
        return _mortgageStatus;
      },

      // Date that the user submitted the Mortgage Application Type form
      mortgageStarted: function mortgageStarted(_mortgageStarted) {
        if (_mortgageStarted) return _mortgageStarted.substring(0, 10);
      },

      // Date that the user submitted their Mortgage Application
      mortgageSubmitted: function mortgageSubmitted(mortgageStatus) {
        if (mortgageStatus) return mortgageStatus.substring(0, 10);
      }
    },

    'card-information-view': {
      event: 'DLevent.CardStatus',
      CardStatus: function CardStatus() {
        var models = this.presenter.models;
        var card = models.card;
        var cardOrder = models.cardOrder;

        if (this.presenter.hasAction('account.index_cards')) {
          if (card) {
            var cardlimits = card.card_limits;
            // if new card is a replacement or additional in ready state, use previous card state
            if (cardOrder && card.card_order_id == cardOrder.id && cardOrder.order_type != 'INITIAL_CARD' && cardlimits.fis_status == 'READY') {
              if (cardOrder.order_type == 'NEW_DESIGN') return 'Activated';
              if (cardOrder.order_type == 'REPLACEMENT') return 'Lost';
            } else if (cardlimits) {
              if (cardlimits.fis_status == 'READY') {
                var replaced = '';
                if (card.hasOwnProperty('replaced_card_id') && card.replaced_card_id > 0) {
                  replaced = 'Re-ordered ';
                }

                if (this.presenter.hasAction('card.activate_card_paid')) {
                  var currentDate = new Date();
                  var estDelivery = new Date(card.estimated_delivery_at);
                  estDelivery = Date.getOtherTimezoneTime(estDelivery, -300);
                  if (currentDate <= estDelivery) {
                    return replaced + 'Ready >= 72';
                  }
                  return replaced + 'Ready > Estimated';
                }
                return replaced + 'Ready < 72';
              }
              if (cardlimits.fis_status == 'ACTIVE') {
                return 'Activated';
              }
              if (cardlimits.fis_status == 'FRAUD') {
                return 'Fraud';
              }
              if (cardlimits.fis_status == 'PFRAUD') {
                return 'Potential Fraud';
              }
              if (cardlimits.fis_status == 'LOST') {
                return 'Lost' + (this._getReplacementCardAvailability() ? ' - Replaceable' : '');
              }
              if (cardlimits.fis_status == 'SUSPENDED') {
                return 'Suspended';
              }
              if (cardlimits.fis_status == 'CLOSED') {
                return 'Closed';
              }
            }
          } else if (cardOrder) {
            if (cardOrder.payment_status === 'PAID') {
              return 'Order Connection Issue';
            }
            if (cardOrder.payment_status == 'PAYMENT_PENDING' || cardOrder.payment_status == 'TIMEOUT') {
              return 'Payment Timeout';
            }
            if (cardOrder.payment_status == 'PENDING') {
              return 'Order incomplete';
            }
          } else if (this.presenter.hasAction('cardOrders.create_card_order') || this.presenter.hasAction('card.create_card_order_secondary')) {
            return 'Eligible';
          } else {
            return 'Not Eligible';
          }
        } else {
          return 'Unavailable';
        }
      },
      AdditionalCard: function AdditionalCard() {
        var models = this.presenter.models;

        if (models.card) {
          var card = models.card;
          var cardOrder = models.cardOrder;

          if (cardOrder && cardOrder.order_type == 'NEW_DESIGN' && card.card_limits.fis_status == 'READY') {
            if (this.presenter.hasAction('card.activate_card_paid')) {
              var currentDate = new Date();
              var estDelivery = new Date(card.estimated_delivery_at);
              estDelivery = Date.getOtherTimezoneTime(estDelivery, -300);
              if (currentDate <= estDelivery) {
                return 'Ready >= 72 - App';
              }
              return 'Ready > Estimated - App';
            }
            return 'Ready < 72 - App';
          }
          if (card.card_limits.fis_status == 'ACTIVE' && cardOrder && models.cards.body.filter(function (card) {
            return card.card_order_id === cardOrder.id;
          }).length == 0) {
            if (cardOrder.payment_status === 'PAID') {
              return 'Order Connection Issue';
            }
            if (cardOrder.payment_status == 'PAYMENT_PENDING' || cardOrder.payment_status == 'TIMEOUT') {
              return 'Payment Timeout';
            }
            if (cardOrder.payment_status == 'PENDING') {
              return 'Order incomplete';
            }
          } else {
            return null;
          }
        } else {
          return null;
        }
      },
      ReplacementCard: function ReplacementCard() {
        var models = this.presenter.models;

        if (models.card) {
          var card = models.card;
          var cardOrder = models.cardOrder;

          if (cardOrder && cardOrder.order_type == 'REPLACEMENT' && card.card_limits.fis_status == 'READY') {
            if (this.presenter.hasAction('card.activate_card_paid')) {
              var currentDate = new Date();
              var estDelivery = new Date(card.estimated_delivery_at);
              estDelivery = Date.getOtherTimezoneTime(estDelivery, -300);
              if (currentDate <= estDelivery) {
                return 'Ready >= 72 - App';
              }
              return 'Ready > Estimated - App';
            }
            return 'Ready < 72 - App';
          }
          if (card.card_limits.fis_status == 'LOST' && cardOrder && models.cards.body.filter(function (card) {
            return card.card_order_id === cardOrder.id;
          }).length == 0) {
            if (cardOrder.payment_status === 'PAID') {
              return 'Order Connection Issue';
            }
            if (cardOrder.payment_status == 'PAYMENT_PENDING' || cardOrder.payment_status == 'TIMEOUT') {
              return 'Payment Timeout';
            }
            if (cardOrder.payment_status == 'PENDING') {
              return 'Order incomplete';
            }
          } else if (models.cards && models.cards.body && models.cards.body.filter(function (card) {
            return card.card_order_id === cardOrder.id;
          }).length > 0 && card.card_limits.fis_status == 'LOST') {
            return 'Not Ordered';
          } else {
            return null;
          }
        } else {
          return null;
        }
      },
      PendingClearing: function PendingClearing() {
        var lastTransaction = this.presenter.getModelProperty('card.last_transaction');
        if (lastTransaction && lastTransaction.non_instant_amount != 0 && lastTransaction.non_instant_fis_decision != 'COMPLETE') {
          return 'Yes';
        }
        return 'No';
      },
      Balance: function Balance() {
        if (this.presenter.hasAction('account.index_cards') && this.presenter.models.card && this.presenter.models.card.card_limits) {
          var card = this.presenter.models.card;

          var cardlimits = card.card_limits;
          var lastTransaction = card.last_transaction;
          if (cardlimits.auth_bal < 0) {
            if (!this.presenter.hasAction('card.load_card_aft')) {
              if (lastTransaction && lastTransaction.payment_method == 'AUTO_EFT') {
                return 'NSF - auto pending';
              }
              if (lastTransaction && lastTransaction.payment_method == 'MANUAL_EFT') {
                return 'NSF - manual pending';
              }
            } else return 'NSF';
          } else if (cardlimits.fis_status == 'ACTIVE') {
            if (!this.presenter.hasAction('card.load_card_aft')) {
              return 'Positive - pending';
            }
            return 'Positive';
          } else {
            return 'Unavailable';
          }
        } else {
          return 'Unavailable';
        }
      },
      UpgradeCard: function UpgradeCard() {
        // Same logic as data-view on link
        if (this.presenter.hasAction('card.create_card_order_secondary') && !this.presenter.hasAction('card.create_card_order_replacement')) {
          return 'Eligible';
        }
        return 'Not Eligible';
      }
    },

    'card-information-pending-clearing': {
      event: 'DLevent.PendingClearingStatus',
      PendingClearing: function PendingClearing() {
        var lastTransaction = this.presenter.getModelProperty('card.last_transaction');
        if (lastTransaction && lastTransaction.non_instant_amount != 0 && lastTransaction.non_instant_fis_decision != 'COMPLETE') {
          return 'Yes';
        }
        return 'No';
      }
    },

    'card-spending-goal': {
      event: 'DLevent.SpendingStatus',
      spendingStatus: function spendingStatus(val) {
        var lastTransaction = this.presenter.getModelProperty('card.last_transaction');
        var spendingGoal = this.presenter.getModelProperty('spendingGoal.spending_goals[0]');
        if (arguments.length > 0) {
          return val;
        }
        if (!lastTransaction) {
          return 'No Transactions';
        }
        if (spendingGoal && spendingGoal.created_at) {
          if (lastTransaction.non_instant_amount > 0 && lastTransaction.non_instant_fis_decision != 'COMPLETE') {
            return 'In progress';
          }
          if (spendingGoal.completed_at) {
            if (spendingGoal.failed) {
              return 'Failed';
            }
            return 'Completed';
          }
          return 'In progress';
        }
        return 'No Goal';
      }
    },

    'card-order-cancel': {
      event: 'DLevent.CardNavigation',
      CardNavigation: 'Cancel Modal Shown'
    },

    'card-freeze': {
      event: 'DLevent.MogoCardLost',
      userAction: function userAction(isFrozen) {
        if (isFrozen) return 'Freeze';
        return 'Unfreeze';
      }
    },

    'card-freeze-modal-close': {
      event: 'DLevent.MogoCardLost',
      userAction: 'Lost or Stolen Close'
    },

    'signup-intro-view': {
      event: 'DLevent.Pageview',
      Page: '/signup/intro'
    },
    'form-submit': {
      event: 'DLevent.FormSubmit',
      FormID: function FormID(formAnalyticsID) {
        return formAnalyticsID;
      },
      LTV: function LTV(ltv) {
        if (ltv) return ltv;
        return null;
      }
    },
    'hd-cell-status': {
      event: 'DLevent.HDCellStatus',
      cell: function cell(_cell) {
        return _cell;
      },
      notification: function notification(_notification) {
        if (_notification) return _notification;
        return null;
      }
    },
    'hd-cell-status-connection-error': {
      event: 'DLevent.HDCellStatusConnectionError',
      cell: function cell(_cell2) {
        return _cell2;
      },
      notification: function notification(_notification2) {
        if (_notification2) return _notification2;
        return null;
      }
    },
    'account-signup-uuid-match': {
      originalUUID: function originalUUID(UUID) {
        return UUID;
      },
      replicateUUID: function replicateUUID(UUID) {
        return UUID;
      },

      event: 'DLevent.EUIDmatch'
    },
    'account-devices': {
      event: 'DLevent.authDev',
      AuthenticatedDevices: function AuthenticatedDevices(number) {
        return number;
      }
    },
    'account-status': {
      event: 'DLevent.AccountStatusUpdate',
      AccountStatus: function AccountStatus(status) {
        switch (status) {
          case 'password-changed':
            return 'PasswordResetSuccess';
          case 'email-verified':
            return 'Email verified';
          case 'login-success':
            return 'Login';
          case 'customer-passed-kyc':
            return 'Identity verified';
          case 'verification-level-4':
            return 'Verification level 4';
          case 'declined':
            return 'Declined';
          case 'permanently_failed':
            return 'Permanently Failed';
          case 'profile_not_found':
            return 'Reason Code 45';
          default:
            console.error(status + ' is not a valid status');
        }
      }
    },
    'fraud-status': {
      event: 'DLevent.FraudStatusUpdate',
      VerificationStatus: function VerificationStatus(decision) {
        if (decision) {
          // change decision to lower case
          decision = decision.toLowerCase();
        }
        switch (decision) {
          case 'accept':
            return 'IdentityAccepted';
          case 'challenge':
            return 'IdentityChallenged';
          case 'deny':
            return 'IdentityDenied';
          case 'script-error':
            return 'IdentityChallenged - Script';
          default:
            console.error(decision + ' is not a valid decision');
        }
      }
    },
    'identity-verified': {
      event: 'DLevent.VerificationStatusUpdate',
      VerificationStatus: 'IdentityVerified',
      CardStatus: 'Not ordered',
      AccountStatus: 'Member'
    },
    'customer-employment-type': {
      EmploymentType: function EmploymentType(value) {
        return value;
      }
    },
    'customer-birthday': {
      event: 'DLevent.ProfileFormInput',
      Birthday: function Birthday(value) {
        return value;
      }
    },
    'customer-salary': {
      event: 'DLevent.ProfileFormInput',
      AnnualIncome: function AnnualIncome(value) {
        return value;
      }
    },
    'form-errors': {
      FormErrors: function FormErrors(fieldsWithError) {
        return fieldsWithError;
      },
      ErrorNotificationContent: function ErrorNotificationContent(failedReason) {
        return failedReason;
      },

      event: 'DLevent.FormErrors'
    },
    'form-abandoned': {
      FormAbandoned: function FormAbandoned(fieldsInteractedWith) {
        return fieldsInteractedWith;
      },

      event: 'DLevent.FormExit'
    },
    formAutoComplete: {
      formAutoComplete: 'selected',
      event: 'DLevent.formAutoComplete'
    },
    'login-dialog': {
      event: 'DLevent.Pageview',
      Page: '/login-dialog'
    },
    'login-account-data': {
      event: 'DLevent.AccountMemberUUID2017',
      UUID: function UUID(_UUID) {
        return _UUID;
      },
      AccountCreationDate: function AccountCreationDate(creationDate) {
        return creationDate;
      },
      MemberCreationDate: function MemberCreationDate(completionDate) {
        if (completionDate) return completionDate;
        return null;
      },
      LTV: function LTV(ltv) {
        if (ltv) return ltv;
        return null;
      }
    },

    'login-card-data': {
      event: 'DLevent.CardSignupDate2017',
      CardSignupDate: function CardSignupDate(signupDate) {
        if (signupDate) return signupDate.substring(0, 10);
        return null;
      }
    },
    'mogo-money-status': {
      event: 'DLevent.LoanStatus2018',
      CreditSeekerStatus: function CreditSeekerStatus() {
        var status = this.presenter.getModelProperty('account.credit_seeker_status');
        switch (status) {
          case 'dormant_lead':
            return 'Dormant';
          case 'cold_lead':
            return 'Cold';
          case 'warm_lead':
            return 'Warm';
          case 'hot_lead':
            return 'Hot';
        }
        return null;
      },
      CreditSeekerApr: function CreditSeekerApr() {
        return this.presenter.getModelProperty('account.credit_seeker_apr');
      },
      CreditCheckDecision: function CreditCheckDecision() {
        return this.presenter.getModelProperty('account.credit_check_decision');
      },
      OfferLender: function OfferLender() {
        var offerStatus = this._getOfferStatus();
        var result = null;
        if (offerStatus) {
          result = this._activeOffer.getOfferLenderName();
        }
        return result;
      },
      OfferProduct: function OfferProduct() {
        var offerStatus = this._getOfferStatus();
        var result = null;
        if (offerStatus) {
          result = this._activeOffer.getOfferName();
        }
        return result;
      },
      OfferApr: function OfferApr() {
        var offerStatus = this._getOfferStatus();
        var result = null;
        if (offerStatus) {
          result = this._activeOffer.getOfferApr();
        }
        return result;
      },
      OfferType: function OfferType() {
        var offerStatus = this._getOfferStatus();
        var result = null;
        if (offerStatus) {
          result = this._activeOffer.getOfferType();
        }
        return result;
      },
      PreviousOfferProduct: function PreviousOfferProduct() {
        return this._expiredOffer.getOfferName();
      },
      OfferStatus: function OfferStatus() {
        var result = 'expired';
        var os = this._getOfferStatus();
        var ls = this._getLoanStatus();
        var expireInDays = this._getDaysBeforeExpiration();
        if (os === 'declined') {
          result = 'none';
        } else if (os === 'refresh') {
          result = os;
        } else if (!ls || ls.status === 'none' || os === 'active') {
          if (os === 'active' && this._activeOffer.isOfferPaused()) {
            result = 'on hold';
          } else if (expireInDays > 7) {
            result = 'not expired';
          } else if (expireInDays != null && expireInDays > -1 && expireInDays < 8) {
            result = 'expiring';
          } else {
            result = 'expired';
          }
        } else {
          result = null;
        }
        return result;
      },
      OfferId: function OfferId() {
        var os = this._getOfferStatus();
        if (os === 'active') {
          if (this._activeOffer && this._activeOffer.getOfferData()) {
            return this._activeOffer.getOfferData().id;
          }
        }
        return null;
      },
      ApplicationLender: function ApplicationLender() {
        return this._getApplicationLender();
      },
      ApplicationStatus: function ApplicationStatus() {
        var result = this._getApplicationStatus();
        if (!this._getApplicationStatus()) {
          return null;
        }
        if (this._getApplicationStatus().system === 'fs') {
          return null;
        }

        if (this._loanApplications.length) {
          var status = this._getStatusAnalytics();
          if (status) {
            return status;
          }
          if (result) result = result.status;
          return result;
        }
        return null;
      },
      ApplicationId: function ApplicationId() {
        var appStatus = this._getApplicationStatus();
        if (appStatus && appStatus.system !== 'fs') {
          if (this._loanApplications[0]) {
            return this._loanApplications[0].getLoanApplicationId();
          }
        }
      },
      BankStatus: function BankStatus() {
        var result = this._getBankVerificationStatus();
        if (result) result = result.status;
        return result;
      },
      BankType: function BankType() {
        var result = this._getBankVerificationStatus();
        if (result) result = result.type;
        return result;
      },
      AgreementsStatus: function AgreementsStatus() {
        var result = this._getAgreementsStatus();
        return result;
      },
      LoanLender: function LoanLender() {
        return this._getLoanLender();
      },
      LoanStatus: function LoanStatus() {
        var result = this._getLoanStatus();
        if (result) result = result.status;
        return result;
      },
      LoanType: function LoanType() {
        var ls = this._getLoanStatus();
        var result = null;
        if (ls && ls.status === 'active') {
          if (this.presenter.getModelProperty('money.loans.loans[0].product_type') === 'liquid') {
            result = 'liquid';
          } else {
            result = this.presenter.getModelProperty('money.loans.fs_loans.loan_type');
          }
        }
        return result;
      }
    },

    'trust-science': {
      event: 'DLevent.trustscience'
    },

    'loan-amount-customization': {
      event: 'DLevent.LoanAmountCustomization',
      LoanAmountCustomization: function LoanAmountCustomization(string) {
        return string;
      },
      LoanAmountAdvanced: function LoanAmountAdvanced(string) {
        return string;
      }
    },

    'loan-custom-options': {
      event: 'DLevent.LoanAmountOptions',
      LoanCustomOptionsLP: function LoanCustomOptionsLP(string) {
        return string;
      },
      LoanCustomOptionsMaxAmount: function LoanCustomOptionsMaxAmount(amount) {
        return amount;
      }
    },

    'digital-loan-application-choices': {
      event: 'DLevent.DLLApplicationChoices',
      DLLAmount: function DLLAmount(amount) {
        if (amount) return amount;
      },
      DLLLP: function DLLLP(lp) {
        var choice = 'Unavailable';
        if (lp !== null) choice = lp;
        return choice;
      },
      DLLBalance: function DLLBalance(eb) {
        if (!eb) return 0;
        return eb;
      }
    },
    'loan-preapproval-data': {
      // This event requires _MoneyController scope
      event: 'DLevent.LoanStatus2017',
      LoanStatus: function LoanStatus(loanStatus) {
        return loanStatus;
      },
      ProductApproved: function ProductApproved(loanOffers) {
        return loanOffers;
      },
      ExpiryDate: function ExpiryDate(expiryDate) {
        return expiryDate;
      },
      PreviousOffer: function PreviousOffer(previousOffer) {
        return previousOffer;
      },
      OfferType: function OfferType(offerType) {
        return offerType;
      },
      apr: function apr(_apr) {
        return _apr;
      },
      userHasPaidOffLoan: function userHasPaidOffLoan() {
        if (this.presenter.getModelProperty('money.loans.fs_loans.loan_status') === 'paid_off') {
          return 'yes';
        }
        return 'no';
      },
      userCanRefreshOffer: function userCanRefreshOffer() {
        if (this.presenter.hasAction('money.offers.get_credit_detail')) {
          return 'yes';
        }
        return 'no';
      }
    },
    'loan-selection': {
      LoanSelected: function LoanSelected(amount) {
        return parseInt(amount);
      },
      PaymentFrequency: function PaymentFrequency(freq) {
        switch (freq) {
          case 'biweekly':
            return 'Bi-weekly';
          case 'monthly':
            return 'Monthly';
        }
        return null;
      }
    },
    'loan-agreement-automation': {
      event: 'DLevent.agreementAutomation',
      automatedAgreement: function automatedAgreement(products) {
        return products;
      }
    },
    'card-activation': {
      CardActivationStatus: 'Activated',
      event: 'DLevent.CardActivationStatusUpdate'
    },
    'card-activation-error': {
      CardActivationStatus: 'Rejected',
      event: 'DLevent.CardActivationStatus'
    },
    'card-interac-availability': {
      Interac: function Interac(interacStatus) {
        return interacStatus;
      }
    },
    'card-limits-reached': {
      Blocked: function Blocked(reason) {
        return reason;
      }
    },
    'card-limits-reached-event': {
      event: 'DLevent.LoadBlocked',
      Blocked: function Blocked(reason) {
        return reason;
      }
    },
    'card-load-settlement': {
      cardUI: 'settlement'
    },
    'card-load-blocked-event': {
      event: 'DLevent.CardLoadBlocked',
      Blocked: function Blocked(reason) {
        return reason;
      }
    },
    'card-load-success-submitted': {
      event: 'DLevent.FormSubmit',
      FormID: function FormID($node) {
        return $node.attr('data-analytics-id');
      }
    },
    'card-load-success-loaded': {
      event: 'DLevent.LoadStatusUpdate',
      CardStatus: function CardStatus() {
        if (this.presenter.models.card.card_load_transaction.instant_amount && this.presenter.models.card.card_load_transaction.instant_amount > 0) {
          return 'Funds Loaded';
        }
        return undefined;
      },
      PendingClearing: function PendingClearing() {
        if (this.presenter.models.card.card_load_transaction.non_instant_amount && this.presenter.models.card.card_load_transaction.non_instant_amount > 0) {
          return 'Yes';
        }
        return undefined;
      }
    },
    'card-load-fail': {
      event: 'DLevent.LoadStatusUpdate',
      Issue: function Issue(reason) {
        return reason;
      }
    },
    'card-pin-shown': {
      event: 'DLevent.ShowPin',
      'See my PIN': 'PIN shown'
    },
    'card-design-view': {
      event: 'DLevent.CardDesign',
      CardDesign: function CardDesign(name) {
        return name;
      },
      DesignStatus: function DesignStatus(status) {
        return status;
      }
    },
    'card-design-image': {
      event: 'DLevent.CardDesignImage',
      CardDesignImage: function CardDesignImage(position, total) {
        return position + ' of ' + total;
      }
    },
    'card-creation': {
      event: 'DLevent.CardCreationProcess',
      CardCreationProcess: function CardCreationProcess(status) {
        return status;
      },
      CardDesign: function CardDesign(name) {
        return name;
      },
      CardPrice: function CardPrice(price) {
        return price;
      }
    },
    'card-payment': {
      event: 'DLevent.CardPaymentProcess',
      CardPaymentProcess: function CardPaymentProcess(status) {
        return status;
      },
      CardDesign: function CardDesign(name) {
        return name;
      },
      CardPrice: function CardPrice(price) {
        return price;
      }
    },
    'card-eTransfer-copy': {
      event: 'DLevent.eTransferCopy',
      eTransferCopy: function eTransferCopy(fieldName) {
        return fieldName;
      }
    }
  }, _defineProperty(_analyticsData, 'card-eTransfer-copy', {
    event: 'DLevent.eTransferCopy',
    eTransferCopy: function eTransferCopy(fieldName) {
      return fieldName;
    }
  }), _defineProperty(_analyticsData, 'activation-state-bitcoin-cashback', {
    event: 'DLevent.genericEvent',
    category: 'MogoCard',
    action: 'bitcoin cashback activation state',
    label: function label(cardActivationState, cryptoActivationState, friendReferralState) {
      var cardValue = cardActivationState ? 'on' : 'off';
      var cryptoValue = cryptoActivationState ? 'on' : 'off';
      var referralValue = friendReferralState ? 'on' : 'off';

      return 'card ' + cardValue + ' and bitcoin ' + cryptoValue + ' and referral ' + referralValue;
    }
  }), _defineProperty(_analyticsData, 'expired-session', {
    event: 'DLevent.Logout',
    Logout: 'Time out'
  }), _defineProperty(_analyticsData, 'logged-out', {
    event: 'DLevent.Logout',
    Logout: 'Success'
  }), _defineProperty(_analyticsData, 'loan-protection-selection', {
    loanProtection: function loanProtection(isProtected) {
      var value = 'yes';
      if (!isProtected) value = 'no';
      return value;
    },
    protectionCost: function protectionCost(_protectionCost) {
      return _protectionCost;
    }
  }), _defineProperty(_analyticsData, 'loan-selection-amount-change', {
    LoanSelected: function LoanSelected(amount) {
      return amount;
    }
  }), _defineProperty(_analyticsData, 'loan-selection-frequency-change', {
    PaymentFrequency: function PaymentFrequency(freq) {
      if (freq === 'monthly') return 'Monthly';
      return 'Bi-weekly';
    }
  }), _defineProperty(_analyticsData, 'loan-option-form-submit', {
    event: 'DLevent.FormSubmit',
    FormID: function FormID($node) {
      return $node.attr('data-analytics-id');
    }
  }), _defineProperty(_analyticsData, 'loan-payment-date-choice', {
    FirstPaymentDate: function FirstPaymentDate(lastMonthSelected) {
      if (lastMonthSelected === 'true') {
        return 'Last Day of Month';
      }
      return 'Picked a Date';
    }
  }), _defineProperty(_analyticsData, 'loan-protection-choice', {
    loanProtection: function loanProtection(isProtected) {
      if (isProtected === 'true') {
        return 'Yes';
      }
      return 'No';
    },
    protectionCost: function protectionCost(cost) {
      return cost;
    }
  }), _defineProperty(_analyticsData, 'mortgage-choices', {
    event: 'DLevent.mortgageChoices',
    applicationType: function applicationType(_applicationType) {
      switch (_applicationType) {
        case 'pre_approval':
          return 'Preapproval';
        case 'home_purchase':
          return 'Home Purchase';
        case 'refinance':
          return 'Refinance';
      }
    },
    applicantInfo: function applicantInfo(_applicantInfo) {
      switch (_applicantInfo) {
        case 'co_applicant':
          return 'Coapplicant';
        case 'co_signer':
          return 'Cosigner';
        case 'solo':
          return 'Solo';
      }
    },
    applicantLiabilities: function applicantLiabilities(applicantInfo) {
      switch (applicantInfo) {
        case true:
          return 'Yes';
        case false:
          return 'No';
      }
    },
    coLiabilities: function coLiabilities(applicantInfo) {
      switch (applicantInfo) {
        case true:
          return 'Yes';
        case false:
          return 'No';
      }
    },
    bankrupt: function bankrupt(applicantInfo) {
      switch (applicantInfo) {
        case true:
          return 'Yes';
        case false:
          return 'No';
      }
    }
  }), _defineProperty(_analyticsData, 'mortgage-rates-view', {
    event: 'DLevent.mortgageProducts',
    featuredName: function featuredName(productName) {
      return productName;
    },
    featuredRate: function featuredRate(_featuredRate) {
      return _featuredRate;
    },
    selectedProduct: function selectedProduct(_selectedProduct) {
      return _selectedProduct;
    },
    selectedRate: function selectedRate(_selectedRate) {
      return _selectedRate;
    },
    competingNames: function competingNames(competingBanks) {
      return competingBanks;
    },
    competingRates: function competingRates(_competingRates) {
      return _competingRates;
    }
  }), _defineProperty(_analyticsData, 'loan-offer-feedback-submitted', {
    event: 'DLevent.Feedback',
    FeedbackState: function FeedbackState(position, answer) {
      return 'Submit - # ' + position + ' ' + answer;
    }
  }), _defineProperty(_analyticsData, 'loan-offer-feedback-state', {
    event: 'DLevent.Feedback',
    FeedbackState: function FeedbackState(state) {
      return state;
    }
  }), _defineProperty(_analyticsData, 'promo-banner-close-view', {
    event: 'DLevent.xPromoBanner',
    xPromoContent: function xPromoContent(product) {
      switch (product) {
        case 'money':
          return 'Money';
        case 'marketing_bitcoin_contest':
          return 'Bitcoin';
      }
    },
    promoID: function promoID(entry, version) {
      if (entry) return entry + '_' + version;
    }
  }), _defineProperty(_analyticsData, 'promo-banner-close', {
    event: 'DLevent.xPromoBannerClose'
  }), _defineProperty(_analyticsData, 'tooltip', {
    event: 'DLevent.Tooltip',
    tooltipContent: function tooltipContent(content) {
      return content;
    }
  }), _defineProperty(_analyticsData, 'abl-success', {
    event: 'DLevent.ABLsuccess',
    ABLBank: function ABLBank(theNameOfTheBank) {
      return theNameOfTheBank;
    }
  }), _defineProperty(_analyticsData, 'abs-status', {
    event: 'DLevent.ABSstatus',
    Status: function Status(status) {
      if (arguments.length > 0) {
        return status;
      }
      return 'success';
    },
    ABSBank: function ABSBank(theNameOfTheBank) {
      return theNameOfTheBank;
    }
  }), _defineProperty(_analyticsData, 'plaid-action', {
    event: 'DLevent.plaidAction',
    action: function action(_action2) {
      return _action2;
    },
    psid: function psid(val) {
      return val;
    },
    view: function view(val) {
      return val;
    },
    query: function query(val) {
      return val;
    },
    institution: function institution(val) {
      return val;
    },
    MFA: function MFA(val) {
      return val;
    },
    Code: function Code(val) {
      return val;
    },
    Msg: function Msg(val) {
      return val;
    },
    Key: function Key(val) {
      return val;
    },
    Exit: function Exit(val) {
      return val;
    }
  }), _defineProperty(_analyticsData, 'promo-code', {
    event: 'DLevent.promoCode',
    PromoCode: function PromoCode(state) {
      return state;
    },
    IDProtectPromoType: function IDProtectPromoType(braintreeDiscountId) {
      return braintreeDiscountId;
    }
  }), _defineProperty(_analyticsData, 'marketing-consent-view', {
    event: 'DLevent.MarketingConsent',
    MarketingConsent: function MarketingConsent(status) {
      if (status === true) {
        return 'Opt in view';
      }
      if (status === false) {
        return 'Opt out view';
      }
    }
  }), _defineProperty(_analyticsData, 'marketing-consent-dialog-view', {
    event: 'DLevent.MarketingConsent',
    MarketingConsent: function MarketingConsent(status) {
      if (status === true) {
        return 'Opt out shown';
      }
      if (status === false) {
        return 'Opt in shown';
      }
    }
  }), _defineProperty(_analyticsData, 'marketing-consent-dialog-close', {
    event: 'DLevent.MarketingConsent',
    MarketingConsent: function MarketingConsent(status) {
      if (status === true) {
        return 'Opt out close';
      }
      if (status === false) {
        return 'Opt in close';
      }
    }
  }), _defineProperty(_analyticsData, 'marketing-consent-update', {
    event: 'DLevent.MarketingConsent',
    MarketingConsent: function MarketingConsent(status, result) {
      if (status === true) {
        return 'Opted out ' + result;
      }
      if (status === false) {
        return 'Opted in ' + result;
      }
    }
  }), _defineProperty(_analyticsData, 'protect-consent-view', {
    event: 'DLevent.ProtectConsent',
    ProtectConsent: function ProtectConsent(status) {
      if (status === true) {
        return 'Opt in view';
      }
      if (status === false) {
        return 'Opt out view';
      }
    }
  }), _defineProperty(_analyticsData, 'protect-consent-dialog-view', {
    event: 'DLevent.ProtectConsent',
    ProtectConsent: function ProtectConsent(status) {
      if (status === true) {
        return 'Opt out shown';
      }
      if (status === false) {
        return 'Opt in shown';
      }
    }
  }), _defineProperty(_analyticsData, 'protect-consent-dialog-close', {
    event: 'DLevent.ProtectConsent',
    ProtectConsent: function ProtectConsent(status) {
      if (status === true) {
        return 'Opt out close';
      }
      if (status === false) {
        return 'Opt in close';
      }
    }
  }), _defineProperty(_analyticsData, 'protect-consent-update', {
    event: 'DLevent.ProtectConsent',
    ProtectConsent: function ProtectConsent(status, result) {
      if (status === true) {
        return 'Opted out ' + result;
      }
      if (status === false) {
        return 'Opted in ' + result;
      }
    }
  }), _defineProperty(_analyticsData, 'help-desk', {
    event: 'DLevent.helpDeskQuestions',
    helpDeskQuestions: function helpDeskQuestions(questions) {
      if (questions) {
        return questions;
      }
      return 'Common Questions';
    },
    helpDeskIDs: function helpDeskIDs(ids) {
      return ids;
    }
  }), _defineProperty(_analyticsData, 'success-notification', {
    event: 'DLevent.SuccessNotification',
    successNotification: function successNotification(action) {
      return action;
    },
    successNotificationProduct: function successNotificationProduct(product) {
      return product;
    }
  }), _defineProperty(_analyticsData, 'error-notification', {
    event: 'DLevent.ErrorNotification',
    errorNotificationProduct: function errorNotificationProduct(product) {
      return product;
    },
    errorNotificationContent: function errorNotificationContent(contentDescription) {
      return contentDescription;
    }
  }), _defineProperty(_analyticsData, 'warning-notification', {
    event: 'DLevent.WarningNotification',
    notification: function notification(identifier) {
      return identifier;
    },
    notificationAction: function notificationAction(action) {
      return action;
    }
  }), _defineProperty(_analyticsData, 'terms-scroll-percentage', {
    event: 'DLevent.TCScroll',
    TCScroll: function TCScroll(percentage) {
      return percentage;
    }
  }), _defineProperty(_analyticsData, 'contentful-content', {
    event: 'DLevent.contentfulContent',
    contentfulObject: function contentfulObject(object) {
      return object;
    },
    contentfulObjectID: function contentfulObjectID(id) {
      return id;
    }
  }), _defineProperty(_analyticsData, 'contentful', {
    event: 'DLevent.Contentful',
    type: function type(_type3) {
      return _type3;
    },
    category: function category(_category3) {
      return _category3;
    },
    content: function content(_content) {
      return _content;
    },
    version: function version(_version) {
      return _version;
    }
  }), _defineProperty(_analyticsData, 'modal-dialog', {
    event: 'DLevent.modalDialog',
    modalDialogID: function modalDialogID(identifier) {
      return identifier;
    },
    modalDialogAction: function modalDialogAction(action) {
      return action;
    }
  }), _defineProperty(_analyticsData, 'nc-status', {
    event: 'DLevent.NCStatus',
    notification: function notification(newNotificationCount) {
      return newNotificationCount;
    }
  }), _defineProperty(_analyticsData, 'nc-notification-status', {
    event: 'DLevent.NCNotificationStatus',
    message: function message(notificationCount) {
      return notificationCount;
    }
  }), _defineProperty(_analyticsData, 'cc-status', {
    event: 'DLevent.CCStatus',
    message: function message(_message2) {
      return _message2;
    }
  }), _defineProperty(_analyticsData, 'card-status', {
    event: 'DLevent.statusComponent',
    statusObject: 'cardInvite',
    // Invited | Not Invited | Ineligible
    status: function status(_status) {
      return _status;
    }
  }), _defineProperty(_analyticsData, 'card-auto-transfer-state', {
    event: 'DLevent.genericEvent',
    category: 'MogoCard',
    action: 'Settings Auto-transfer State',
    // On | Off | Skipped
    label: function label(status) {
      return status;
    }
  }), _defineProperty(_analyticsData, 'benefit-notification', {
    event: 'DLevent.Notification',
    notification: function notification(_notification3) {
      return _notification3;
    },
    notificationAction: function notificationAction(action) {
      return action;
    }
  }), _analyticsData);

  this.init = function () {};
  this.initAllReady = function () {};
}